






















































































import Vue, { PropType } from 'vue';
import { mapActions, mapGetters } from 'vuex';

import { IUser, IQuote } from '@/models';
import { ErrorManager } from '@/models/error';

import SalesRepPicker from './SalesRepPicker.vue';

export default Vue.extend({
  name: 'SalesRepSelectorFormDialog',

  components: { SalesRepPicker },

  props: {
    quote: { type: Object as PropType<IQuote>, required: true }
  },

  data() {
    return {
      insideSalesOwner: null as null | string | IUser,
      isLoading: false,
      isActive: false,
      isValid: false,
      insideSalesOwnerError: ''
    };
  },

  computed: {
    ...mapGetters({
      getSalesRepById: 'salesRep/getSalesRepById'
    })
  },

  methods: {
    ...mapActions({
      setQuoteInsideSalesOwner: 'quote/setQuoteInsideSalesOwner'
    }),

    clearError() {
      this.insideSalesOwnerError = '';
    },

    saveInsideSalesOwner() {
      this.clearError();
      this.isLoading = true;
      this.setQuoteInsideSalesOwner({
        id: this.quote.number,
        user: this.insideSalesOwner
      })
        .then(() => {
          // save insideSalesOwner string representation to quote directly
          const insideSalesOwnerString = this.getSalesRepById(
            this.insideSalesOwner
          ).fullName;

          this.$emit('save:insideSalesOwner', insideSalesOwnerString);
          this.isActive = false;
        })
        .catch(error => {
          if (error.response.data.detail) {
            this.insideSalesOwnerError = error.response.data.detail;
          } else {
            this.insideSalesOwnerError = ErrorManager.extractApiError(error);
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }
});
